import request, { resolve, post } from '../api/request';
import consts from '../app/constants';
import { resolveRequest } from '../actions/request';
import DesignSketchesStore from '../stores/DesignSketchesStore';
import DesignCollectionStore from '../stores/DesignCollectionStore';
import debounce from 'lodash.debounce';

export function loadDesignSketches(context, { loadDesignSketchesUrl, designId }) {
    context.dispatch(consts.SET_DESIGN_SKETCH_STATE, { state: 'loading', designId });

    const apiRequest = request('GET', loadDesignSketchesUrl, consts.SET_DESIGN_SKETCH);

    resolve(apiRequest)
        .then(sketch => {
            context.dispatch(consts.SET_DESIGN_SKETCH, { designId, sketch });
            context.dispatch(consts.SET_DESIGN_SKETCH_STATE, { state: null, designId });
        })
        .catch(e => {
            context.dispatch(consts.SET_DESIGN_SKETCH_STATE, { state: 'error', designId });
        });
}

export function updateDesignSketches(context, { designId, csrfToken }) {
    context.dispatch(consts.SET_DESIGN_SKETCH_STATE, { state: 'saving', designId });

    const sketch = context.getStore(DesignSketchesStore).getDesignSketch(designId);
    const design = context.getStore(DesignCollectionStore).getDesign(designId);

    const apiRequest = request(
        'POST',
        design.links.updateSketches,
        consts.DESIGN_SKETCH_UPDATE_SUCCESS
    )
        .set('X-Csrf-Token', csrfToken)
        .send(sketch);

    return context
        .executeAction(resolveRequest, { request: apiRequest })
        .then(() => {
            context.dispatch(consts.SET_DESIGN_SKETCH_STATE, { state: 'saved', designId });
        })
        .catch(e => {
            context.dispatch(consts.SET_DESIGN_SKETCH_STATE, { state: 'error', designId });
        });
}

export function undoLastDesignPath(context, { designId, csrfToken }) {
    context.dispatch(consts.UNDO_LAST_DESIGN_PATH, { designId });
    debounceUpdateDesignSketch(context, designId, csrfToken);
}

const debounceUpdateDesignSketch = debounce((context, designId, csrfToken) => {
    context.executeAction(updateDesignSketches, { designId, csrfToken });
}, 1000);

export function addDesignPath(context, { designId, path, csrfToken }) {
    // Round coordinates to the nearest pixel to avoid saving paths with an unnecessary amount of precision
    const roundedPath = path.map(point => ({
        x: Math.round(point.x),
        y: Math.round(point.y),
    }));
    context.dispatch(consts.ADD_DESIGN_PATH, {
        designId,
        path: roundedPath,
    });
    debounceUpdateDesignSketch(context, designId, csrfToken);
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/actions/design-sketches.js